import { Card, Heading, Text } from '@moia-dev/pace-web'
import type { ReactNode } from 'react'

export const AccountLayout = ({
  header,
  subheader,
  children,
}: {
  header: string
  subheader?: string
  children: ReactNode
}) => {
  return (
    <Card padding="small" css={{ maxHeight: 'fit-content' }}>
      <div
        css={theme => ({
          display: 'grid',
          gap: theme.space.Space1,
          paddingBlock: theme.space.Space3,
          paddingInline: theme.space.Space4,
        })}
      >
        <Heading size="lg">{header}</Heading>
        {subheader && <Text color="reduced">{subheader}</Text>}
      </div>
      {children}
    </Card>
  )
}
